module.exports = __webpack_public_path__ + "static/media/CareGiversGuidePageRU.831c3f3f.pdf";